// Tours booked on WhatsApp only (no online deposit)
export default {
  whatsappOnly: {
    badge: 'Booked via WhatsApp',
    note: 'This tour is booked directly with our team on WhatsApp. We confirm availability and arrange payment with you — no advance payment on the website.',
    reserve: 'Book on WhatsApp',
    secure: 'No payment on the website: our team confirms everything with you on WhatsApp.',
    cartNote: 'This order is confirmed on WhatsApp: our team checks availability and arranges payment with you.',
    cartMixed: 'Your cart includes tours that can only be booked on WhatsApp, so the whole order will be confirmed there.',
    stepConfirm: 'WhatsApp',
    formLead: 'Fill in your details and we will send the complete booking to our team on WhatsApp.',
    submit: 'Confirm booking on WhatsApp',
    submitHint: 'WhatsApp opens with the tour, date, guests and your details already filled in.',
  },
};
